import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { IConsultor } from "constants/interfaces/consultor.interface";
import Pagination from "components/Pagination";
import { Option, Select } from "components/Input/Input.styled";
import { Button } from "components/Button/Button.styled";
import { Paragraph, Subtitle, Title } from "components/Text";
import { IGridListProps } from "components/GridList/GridList.interface";
import GridItem from "components/GridList/GridItem";
import ListItem from "components/GridList/ListItem";

const GridList = (props: IGridListProps) => {
  const [viewMode, setViewMode] = useState<"grid" | "list">("list");

  const handleRecordsPerPageChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    props.setData({
      ...props.data,
      isLoading: true,
      pagination: {
        ...props.data.pagination,
        limit: Number.parseInt(e.target.value),
        page: 1,
      },
    });
  };

  if (props.isLoading) {
    return (
      <div className="d-flex justify-content-center my-5">
        <Spinner animation="border" role="output">
          <span className="sr-only">Cargando...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <>
      <div className="d-flex justify-content-end mb-3">
        <Paragraph className="d-flex mr-auto align-items-center result-count">
          <strong className="mr-2">{props.data.pagination.total}</strong>{" "}
          resultados encontrados
        </Paragraph>
        <div className="d-flex align-items-center">
          <Paragraph className="justify-content-center align-items-center d-flex mt-4">
            <label
              className="mr-2 justify-content-center align-items-center d-flex"
              htmlFor="slctViewMode"
            >
              Vista:
            </label>
          </Paragraph>
          <Button
            id="slctViewMode"
            type="button"
            className={`btn btn-${
              viewMode === "list" ? "primary" : "secondary"
            }`}
            onClick={() => setViewMode(viewMode === "list" ? "grid" : "list")}
          >
            {`${viewMode === "list" ? "Lista" : "Grilla"}`}
            <span className={`ml-2 cl cl-list`}></span>
          </Button>
        </div>
      </div>
      {props.data?.data?.length === 0 && (
        <div className="d-flex justify-content-center my-5">
          <p>No se encontraron resultados</p>
        </div>
      )}
      {props.data?.data &&
        (viewMode === "list" ? (
          props.data.data.map((consultor: IConsultor) => (
            <ListItem
              key={consultor.PersonaID}
              title={`${consultor.Nombre} ${
                consultor.ApPaterno ? consultor.ApPaterno : ""
              } ${consultor.ApMaterno ? consultor.ApMaterno : ""}`}
              icon="cl-login"
              onClick={() => props.onItemClick(consultor)}
            >
              <div className="col-12">
                <div className="row align-items-center">
                  <Subtitle className="list-item-title h5 mb-3 mr-3">
                    {`${consultor.Nombre} ${
                      consultor.ApPaterno ? consultor.ApPaterno : ""
                    } ${consultor.ApMaterno ? consultor.ApMaterno : ""}`}
                  </Subtitle>                  
                </div>
                <div className="row">
                  <div className="col">
                    <Paragraph className="font-level-7 text-muted">
                      Nro. Registro
                    </Paragraph>
                    <br />
                    <Paragraph className="list-item-subtitle h6">
                      {consultor.NroRegistro}
                    </Paragraph>
                  </div>
                  <div className="col">
                    <Paragraph className="text-muted">Región</Paragraph>
                    <br />
                    <Paragraph className="list-item-subtitle h6">
                      {!consultor.NombreRegion
                        ? "No especificado"
                        : consultor.NombreRegion}
                    </Paragraph>
                  </div>
                  <div className="col">
                    <Paragraph className="font-level-7 text-muted">
                      Estado
                    </Paragraph>
                    <br />
                    <Paragraph className="list-item-subtitle h6">
                      {consultor.Vigente ? "Vigente" : "No Vigente"}
                    </Paragraph>
                  </div>
                </div>
              </div>
            </ListItem>
          ))
        ) : (
          <div className="row">
            {props.data.data.map((consultor: IConsultor) => (
              <div
                className="col-sm-12 col-md-6 col-lg-4 mt-5"
                key={consultor.PersonaID}
              >
                <GridItem
                  onClick={() => props.onItemClick(consultor)}
                  actions={[
                    {
                      label: "Ver detalles",
                      onClick: () => props.onItemClick(consultor),
                    },
                  ]}
                >
                  <GridItem.Body className="card-organization-body">
                    <Title className="card-title">
                      {`${consultor.Nombre} ${
                        consultor.ApPaterno ? consultor.ApPaterno : ""
                      } ${consultor.ApMaterno ? consultor.ApMaterno : ""}`}
                    </Title>
                    <hr />
                    <Subtitle className="card-label">Nro. Registro</Subtitle>
                    <Paragraph className="card-text">{consultor.NroRegistro}</Paragraph>
                    <Subtitle className="card-label">Región</Subtitle>
                    <Paragraph className="card-text">
                      {consultor.NombreRegion}
                    </Paragraph>
                    <Subtitle className="card-label">Estado</Subtitle>
                    <Paragraph className="card-text">
                      {consultor.Vigente ? "Vigente" : "No Vigente"}{" "}
                    </Paragraph>
                  </GridItem.Body>
                </GridItem>
              </div>
            ))}
          </div>
        ))}
      <div className="text-center col-12">
        <div className="d-flex justify-content-end">
          <div className="mt-3">
            <Paragraph>
              <label htmlFor="slctRecordsPerPage">Registros por página:</label>
            </Paragraph>
            <Select
              className="form-control"
              id="slctRecordsPerPage"
              aria-label="Registros por página"
              value={props.data.pagination.limit}
              onChange={handleRecordsPerPageChange}
            >
              {[10, 20, 50, 100].map((option) => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </div>
        </div>
        <Pagination
          className="mt-5"
          pagination={{
            ...props.data.pagination,
            page: props.data.pagination.page,
          }}
          setData={(newPage: number) =>
            props.setData({
              ...props.data,
              isLoading: true,
              pagination: { ...props.data.pagination, page: newPage },
            })
          }
        />
      </div>
    </>
  );
};

export default GridList;
